import React, { useState } from 'react';
import {
  Button,
  DarkSearchInput,
  ResetFilter,
  SearchableSelect,
} from '../../../component';
import { RouteIcon } from '../../../content/svg-component';
import DarkDateDropdown from '../customerManagement/darkDateDropdown';
const FilterPanel = (props) => {
  const [isShowTripDropDown, setIsShowTripDropDown] = useState(false);
  const [reseting, setReseting] = useState(false);
  const {
    handleResetFilter,
    handleSelectedLocation,
    fetchLocations,
    handleSubmitRoute,
    handleSelectGateWay,
    handleSearchGateWay,
    handleSearch,
    filtersData: {
      originList,
      destinationList,
      gateWaysList,
      selectedGateWay,
      gatewaySearchKey,
      selectedOrigin,
      selectedDestination,
      gatewaySelectorePhrase,
    },
    intl,
    language,
  } = props;

  return (
    <div className="w-100 d-flex text-white">
      <div className="w-100 d-flex flex-row justify-content-between mb-4 font-small text-white px-0 height-tab">
        <div
          className={`col d-flex flex-row justify-content-start align-items-center px-0 h-100`}
        >
          <div className="col-4 px-0 d-flex flex-row justify-content-center h-100">
            <div className="col-11 d-flex justify-content-center px-0">
              <SearchableSelect
                themeMode="light"
                name="searchablegateway"
                id="searchablegateway"
                placeholder={intl.formatMessage({
                  id: 'profile.choosegateway',
                })}
                list={gateWaysList}
                display={`name`}
                type="gateways"
                isLocalization={true}
                search={(event) => handleSearchGateWay(event)}
                select={(item) => handleSelectGateWay(item)}
                defaultValue={selectedGateWay?.name}
                shouldBeFilled={true}
                isOutSideLabel={false}
                containerClass="w-100"
                labelColor={` ${
                  (selectedGateWay?.name || gatewaySelectorePhrase) && 'd-none'
                }`}
                inputClassname="py-1 font-smaller bg-white"
                heightSize={'px-lg-0 px-3'}
                listClass="default-border-bottom-radius-small bg-white text-start text-dark border-color-light-primary"
                py={'py-sm-0'}
                boxColor="bg-white heightResponsive"
                labelPosition="none"
                customPlaceHolderClass="col-9 px-0 text-truncate"
                isReset={reseting}
              />
            </div>
          </div>
          <div className="d-flex col-4 h-100 px-0 justify-content-center">
            <DarkSearchInput
              label="profile.airlinecode"
              className={`col-12 px-0`}
              name="searchKey"
              value={gatewaySearchKey}
              onChange={handleSearch}
            />
          </div>
          <div className="col-4 p-0 d-flex flex-row justify-content-center h-100">
            <DarkDateDropdown
              name="routesDropDown"
              svgIcon={
                <RouteIcon variant="svg-md-small svg-sm-small svg-xs-small svg-tiny" />
              }
              labelClassName={'text-dark'}
              className="w-100 d-flex flex-row justify-content-center"
              label="booking.tripdirection"
              boxColor="bg-white border"
              show={isShowTripDropDown}
              direction={language?.direction}
              onclick={() => setIsShowTripDropDown(!isShowTripDropDown)}
              placement="center"
            >
              <div className="p-3 mx-2">
                <div className="pb-3">
                  <SearchableSelect
                    themeMode="light"
                    name="origin"
                    placeholder={intl.formatMessage({
                      id: 'booking.origin',
                    })}
                    list={originList}
                    display={`name.${language?.name}`}
                    type="city"
                    isLocalization={true}
                    search={(event) => fetchLocations(event, 'origin')}
                    select={(item) => handleSelectedLocation(item, 'origin')}
                    defaultValue={selectedOrigin?.name?.[language?.name]}
                    shouldBeFilled={true}
                    containerClass="w-100"
                    labelColor="text-dark font-smaller"
                    inputClassname="py-1 font-smaller"
                    heightSize={'indropDown px-lg-0 px-3'}
                    listClass="default-border-bottom-radius-small bg-third-light border-color-light-primary"
                    isReset={reseting}
                  />
                </div>
                <div>
                  <SearchableSelect
                    themeMode="light"
                    name="destination"
                    placeholder={intl.formatMessage({
                      id: 'booking.destination',
                    })}
                    list={destinationList}
                    display={`name.${language?.name}`}
                    type="city"
                    isLocalization={true}
                    search={(event) => fetchLocations(event, 'destination')}
                    select={(item) =>
                      handleSelectedLocation(item, 'destination')
                    }
                    defaultValue={selectedDestination?.name?.[language?.name]}
                    shouldBeFilled={true}
                    containerClass="w-100"
                    labelColor="text-dark font-smaller"
                    inputClassname="py-1 font-smaller"
                    heightSize={'indropDown px-lg-0 px-3'}
                    listClass="default-border-bottom-radius-small bg-third-light border-color-light-primary"
                    isReset={reseting}
                  />
                </div>
                <Button
                  name={`search-historyDate`}
                  id={`search-historyDate`}
                  label={intl.formatMessage({
                    id: `profile.search`,
                  })}
                  className="btn-secondary mt-4"
                  disabled={selectedOrigin === '' && selectedDestination === ''}
                  onClick={() => {
                    setIsShowTripDropDown(false);
                    handleSubmitRoute();
                  }}
                />
              </div>
            </DarkDateDropdown>
          </div>
        </div>
        <ResetFilter
          handleReset={() => {
            setIsShowTripDropDown(false);
            handleResetFilter();
            setReseting(!reseting);
          }}
        />
      </div>
    </div>
  );
};
export default FilterPanel;
